export default function translate(i18n, propriete) {
  if (propriete === 'iOT') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.iOT');
  }
  if (propriete === 'nom') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.name');
  }
  if (propriete === 'code') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.code');
  }
  if (propriete === 'commentaire') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.commentaire');
  }
  if (propriete === 'pDLElectricite') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.pDLElectricite');
  }
  if (propriete === 'arretBus') {
    return i18n.t('dispositifPublicitaire.arretBus');
  }
  if (propriete === 'codeTimeo') {
    return i18n.t('dispositifPublicitaire.codeTimeo');
  }
  if (propriete === 'dispositifTechnique.DistanceEnMCablesEdf') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.distanceEnMCablesEdf');
  }
  if (propriete === 'dispositifTechnique.HauteurSousPanneau') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.hauteurSousPanneau');
  }
  if (propriete === 'dispositifTechnique.Particularite') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.particularite');
  }
  if (propriete === 'dispositifTechnique.PlanRecollement') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.recollement');
  }
  if (propriete === 'dispositifTechnique.CouleurRAL') {
    return i18n.t('dispositifPublicitaire.couleurRal');
  }
  if (propriete === 'dispositifTechnique.Obstacle') {
    return i18n.t('detailDispositif.infoTech.obstacle');
  }
  if (propriete === 'dispositifTechnique.RestrictionsAffichage') {
    return i18n.t('dispositifPublicitaire.restrictionsAffichage');
  }
  if (propriete === 'dispositifTechnique.AutreEquipementNecessaire') {
    return i18n.t('dispositifPublicitaire.autreEquipementNecessaire');
  }
  return propriete;
}
